import { render, staticRenderFns } from "./mp3Toolexam.vue?vue&type=template&id=072e9cd7&scoped=true"
import script from "./mp3Toolexam.vue?vue&type=script&lang=js"
export * from "./mp3Toolexam.vue?vue&type=script&lang=js"
import style0 from "./mp3Toolexam.vue?vue&type=style&index=0&id=072e9cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e9cd7",
  null
  
)

export default component.exports